/* eslint-disable react/jsx-key */
import React from 'react';
import { useDispatch } from 'react-redux';
import { Wrapper } from '../styled';
import { CustomCheckMark, StyledLabel, Delete } from './styled';
import { useIntl } from 'react-intl';
import { removeCommand } from 'Common/Components/FileUploadContext/actions';
import { getGroupingCommandFinishedLabel } from 'Common/Components/FileUploadContext/groupingCommands';

const FinishedOk = ({ file }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const commandType = file?.commandType ?? '';
  const warning = file?.warning ?? null;
  const assetsTotal = file?.assetsTotal ?? 0;
  const destinationWsName = file?.destinationWsName ?? '';
  const commandId = file?.command_id ?? 0;
  const mockCommandId = file?.mockCommandId ?? null;

  const message = () => {
    if (commandType === 'moveAssets') {
      const numberSkipped = warning ? warning.split(' ')[0] : 0;
      const successfulMoved = assetsTotal - numberSkipped;
      const successMessage = successfulMoved > 1
        ? `${successfulMoved} assets were moved to ${destinationWsName}.`
        : `1 asset was moved to ${destinationWsName}.`;
      if (numberSkipped && successfulMoved > 0) return `${successMessage} ${warning}`;
      else if ((!numberSkipped && successfulMoved > 0)) return successMessage;
    }
    const groupingLabel = getGroupingCommandFinishedLabel(commandType);
    if (groupingLabel) return groupingLabel;
    if (commandType === 'risk_score_recalculation') return 'Done! Risk scores recalculated.';
    return intl.formatMessage({ id: 'uploadContext.status.finishedOk' });
  };

  return (
    <Wrapper>
      <CustomCheckMark />
      <StyledLabel children={ message() } />
      <Delete onClick={ () => dispatch(removeCommand(commandId, mockCommandId)) } />
    </Wrapper>
  );
};

export default FinishedOk;
